export default __webpack_public_path__ + "static/media/inventory.fc0f7fa2.svg";